import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./pages/Login";

import "./App.css";
import App from "./App";


// import keycloak from "./keycloak";
import keycloak from "./Auth";
import { ReactKeycloakProvider } from "@react-keycloak/web";

const eventLogger = (event, error) => {
  console.log("Keycloak event:", event);
  console.error("Keycloak error:", error);
};

const root = document.getElementById("root");
const reactRoot = ReactDOM.createRoot(root); // Only create the root once
reactRoot.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={{ onLoad: "login-required" }} // Options for Keycloak
    onEvent={eventLogger}
  >
    {/* <RouterProvider router={router} /> */}
    <App />
   
  </ReactKeycloakProvider>
);

window.addEventListener("unhandledrejection", (event) => {});

window.addEventListener("error", (event) => {});





